import { PayinOrderPublicStatus, payinOrderPublicStatuses } from '~/entities/payin';

export const statuses = payinOrderPublicStatuses.filter((status) => {
    return (
        status.value === PayinOrderPublicStatus.PUBLIC_STATUS_COMPLETED ||
        status.value === PayinOrderPublicStatus.PUBLIC_STATUS_FAILED
    );
});
